import { useState } from 'react';
import CandidateProfileReview from './CandidateProfileReview';
import apiClient from '@/lib/api';
export default function CandidateSavedProfile({
  candidate,
  onSaved
}) {
  const [profile, setProfile] = useState(candidate.cv_profile);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  return <div className="space-y-3"><CandidateProfileReview profile={profile} onChange={setProfile} /><button disabled={busy} className="min-h-11 px-4 rounded-lg text-blue-200 border border-white/20" onClick={async () => {
      setBusy(true);
      try {
        await apiClient.put(`/recruitment/candidates/${candidate._id || candidate.id}`, {
          cv_profile: profile
        });
        await onSaved();
        setMessage('Profil enregistré.');
      } catch {
        setMessage('Le profil n’a pas pu être enregistré. Réessayez.');
      } finally {
        setBusy(false);
      }
    }}>Enregistrer les modifications du profil</button><p role="status" className="text-sm text-slate-300">{message}</p></div>;
}
